var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pulse-loader"},_vm._l((8),function(dot){return _c('div',{key:dot,staticClass:"pulse-loader__dot",style:(_vm.getDotPositionStyles(dot))},[_c('div',{class:[
        'pulse-loader__dot-item',
        { 'pulse-loader__dot-item--animated': _vm.currentAnimatedDot === dot },
      ]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }